var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNotificationOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assets",
    transform: "translate(-595.000000, -2770.000000)",
    fill: "#858199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/NotificationOff",
    transform: "translate(595.000000, 2770.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0918831,3.12132034 C20.4824074,3.51184464 20.4824074,4.14500961 20.0918831,4.53553391 L4.53553391,20.0918831 C4.14500961,20.4824074 3.51184464,20.4824074 3.12132034,20.0918831 C2.73079605,19.7013588 2.73079605,19.0681938 3.12132034,18.6776695 L18.6776695,3.12132034 C19.0681938,2.73079605 19.7013588,2.73079605 20.0918831,3.12132034 Z M14,18 C14,19.1 13.1,20 12,20 C10.95,20 10.0822314,19.1799587 10.0055128,18.1486946 L10,18 L14,18 Z M17,9.042 L17,12 C17,13.21875 17.703125,14.1738281 18.3677979,14.8652344 L18.5,15 L19,15 C19.6,15 20,15.4 20,16 C20,16.5571429 19.655102,16.9418367 19.1254373,16.9939504 L19,17 L9.042,17 L17,9.042 Z M5.385,15 L4.04739385,16.3377272 C4.01634882,16.2344276 4,16.121301 4,16 C4,15.4428571 4.34489796,15.0581633 4.87456268,15.0060496 L5,15 L5.385,15 Z M12,4 C13.2403509,4 14.3629617,4.4317136 15.2287476,5.15605605 L6.23534471,14.1517379 C6.62194142,13.6177285 6.93426657,12.9805607 6.99084473,12.2402344 L7,12 L7,9 C7,6.2 9.2,4 12,4 Z",
    id: "Combined-Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationOff);
export default __webpack_public_path__ + "static/media/iconNotificationOff.a82db33b.svg";
export { ForwardRef as ReactComponent };